import {
  FETCH_ACCOUNT_MAXES_START,
  FETCH_ACCOUNT_MAXES_FULFILLED,
  FETCH_ACCOUNT_MAXES_REJECTED,
  FETCH_ACCOUNT_GOALS_START,
  FETCH_ACCOUNT_GOALS_FULFILLED,
  FETCH_ACCOUNT_GOALS_REJECTED,
  FETCH_GROUPS_START,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  FETCH_CALENDARS_START,
  FETCH_CALENDARS_FULFILLED,
  FETCH_CALENDARS_REJECTED,
  FETCH_ATHLETES_START,
  FETCH_ATHLETES_FULFILLED,
  FETCH_ATHLETES_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  CREATE_MAX_EFFORT_START,
  CREATE_MAX_EFFORT_FULFILLED,
  CREATE_MAX_EFFORT_REJECTED,
  SAVE_GOAL_START,
  SAVE_GOAL_FULFILLED,
  SAVE_GOAL_REJECTED,
  DELETE_GOALS_START,
  DELETE_GOALS_FULFILLED,
  DELETE_GOALS_REJECTED,
  FETCH_MAX_HISTORY_START,
  FETCH_MAX_HISTORY_FULFILLED,
  FETCH_MAX_HISTORY_REJECTED,
  FETCH_HISTORY_CURRENT_MAX_START,
  FETCH_HISTORY_CURRENT_MAX_FULFILLED,
  FETCH_HISTORY_CURRENT_MAX_REJECTED,
  SET_MAX_ACTIVE_START,
  SET_MAX_ACTIVE_FULFILLED,
  SET_MAX_ACTIVE_REJECTED,
  ARCHIVE_MAX_START,
  ARCHIVE_MAX_FULFILLED,
  ARCHIVE_MAX_REJECTED,
  SET_MAXES_LOCK_START,
  SET_MAXES_LOCK_FULFILLED,
  SET_MAXES_LOCK_REJECTED,
  RESET_MAXES_START,
  RESET_MAXES_FULFILLED,
  RESET_MAXES_REJECTED,
  BULK_ARCHIVE_MAXES_START,
  BULK_ARCHIVE_MAXES_FULFILLED,
  BULK_ARCHIVE_MAXES_REJECTED,
} from './actionTypes';

const initialState = {
  accountMaxes: [],
  accountMaxesError: null,
  accountGoals: [],
  accountGoalsError: null,
  groups: [],
  groupsError: null,
  calendars: [],
  calendarsError: null,
  athletes: [],
  athletesError: null,
  exercises: [],
  exercisesError: null,
  createMaxEffortError: null,
  saveGoalError: null,
  deleteGoalsError: null,
  maxHistory: [],
  maxHistoryError: null,
  historyCurrentMax: {},
  historyCurrentMaxError: null,
  setMaxActiveError: null,
  archiveMaxError: null,
  maxLockError: null,
  resetMaxesError: null,
  bulkArchiveMaxesError: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNT_MAXES_START: {
      return {
        ...state,
        accountMaxesError: null,
      };
    }
    case FETCH_ACCOUNT_MAXES_FULFILLED: {
      return {
        ...state,
        accountMaxes: action.payload,
      };
    }
    case FETCH_ACCOUNT_MAXES_REJECTED: {
      return {
        ...state,
        accountMaxes: [],
        accountMaxesError: action.payload,
      };
    }
    case FETCH_ACCOUNT_GOALS_START: {
      return {
        ...state,
        accountGoalsError: null,
      };
    }
    case FETCH_ACCOUNT_GOALS_FULFILLED: {
      return {
        ...state,
        accountGoals: action.payload,
      };
    }
    case FETCH_ACCOUNT_GOALS_REJECTED: {
      return {
        ...state,
        accountGoals: [],
        accountGoalsError: action.payload,
      };
    }
    case FETCH_GROUPS_START: {
      return {
        ...state,
        groupsError: null,
      };
    }
    case FETCH_GROUPS_FULFILLED: {
      return {
        ...state,
        groups: action.payload,
      };
    }
    case FETCH_GROUPS_REJECTED: {
      return {
        ...state,
        groups: [],
        groupsError: action.payload,
      };
    }
    case FETCH_CALENDARS_START: {
      return {
        ...state,
        calendarsError: null,
      };
    }
    case FETCH_CALENDARS_FULFILLED: {
      return {
        ...state,
        calendars: action.payload,
      };
    }
    case FETCH_CALENDARS_REJECTED: {
      return {
        ...state,
        calendars: [],
        calendarsError: action.payload,
      };
    }
    case FETCH_ATHLETES_START: {
      return {
        ...state,
        athletesError: null,
      };
    }
    case FETCH_ATHLETES_FULFILLED: {
      return {
        ...state,
        athletes: action.payload,
      };
    }
    case FETCH_ATHLETES_REJECTED: {
      return {
        ...state,
        athletes: [],
        athletesError: action.payload,
      };
    }
    case FETCH_EXERCISES_START: {
      return {
        ...state,
        exercisesError: null,
      };
    }
    case FETCH_EXERCISES_FULFILLED: {
      return {
        ...state,
        exercises: action.payload,
      };
    }
    case FETCH_EXERCISES_REJECTED: {
      return {
        ...state,
        exercises: [],
        exercisesError: action.payload,
      };
    }
    case CREATE_MAX_EFFORT_START: {
      return {
        ...state,
        createMaxEffortError: null,
      };
    }
    case CREATE_MAX_EFFORT_FULFILLED: {
      return {
        ...state,
        createMaxEffortError: null,
      };
    }
    case CREATE_MAX_EFFORT_REJECTED: {
      return {
        ...state,
        createMaxEffortError: action.payload,
      };
    }
    case SAVE_GOAL_START: {
      return {
        ...state,
        saveGoalError: null,
      };
    }
    case SAVE_GOAL_FULFILLED: {
      return {
        ...state,
        saveGoalError: null,
      };
    }
    case SAVE_GOAL_REJECTED: {
      return {
        ...state,
        saveGoalError: action.payload,
      };
    }
    case DELETE_GOALS_START: {
      return {
        ...state,
        deleteGoalsError: null,
      };
    }
    case DELETE_GOALS_FULFILLED: {
      return {
        ...state,
        deleteGoalsError: null,
      };
    }
    case DELETE_GOALS_REJECTED: {
      return {
        ...state,
        deleteGoalsError: action.payload,
      };
    }
    case FETCH_MAX_HISTORY_START: {
      return {
        ...state,
        maxHistoryError: null,
      };
    }
    case FETCH_MAX_HISTORY_FULFILLED: {
      return {
        ...state,
        maxHistory: action.payload,
      };
    }
    case FETCH_MAX_HISTORY_REJECTED: {
      return {
        ...state,
        maxHistory: [],
        maxHistoryError: action.payload,
      };
    }
    case FETCH_HISTORY_CURRENT_MAX_START: {
      return {
        ...state,
        historyCurrentMaxError: null,
      };
    }
    case FETCH_HISTORY_CURRENT_MAX_FULFILLED: {
      return {
        ...state,
        historyCurrentMax: action.payload,
      };
    }
    case FETCH_HISTORY_CURRENT_MAX_REJECTED: {
      return {
        ...state,
        historyCurrentMax: {},
        historyCurrentMaxError: action.payload,
      };
    }
    case SET_MAX_ACTIVE_START: {
      return {
        ...state,
        setMaxActiveError: null,
      };
    }
    case SET_MAX_ACTIVE_FULFILLED: {
      return {
        ...state,
        setMaxActiveError: null,
      };
    }
    case SET_MAX_ACTIVE_REJECTED: {
      return {
        ...state,
        setMaxActiveError: action.payload,
      };
    }
    case ARCHIVE_MAX_START: {
      return {
        ...state,
        archiveMaxError: null,
      };
    }
    case ARCHIVE_MAX_FULFILLED: {
      return {
        ...state,
        archiveMaxError: null,
      };
    }
    case ARCHIVE_MAX_REJECTED: {
      return {
        ...state,
        archiveMaxError: action.payload,
      };
    }
    case SET_MAXES_LOCK_START: {
      return {
        ...state,
        maxLockError: null,
      };
    }
    case SET_MAXES_LOCK_FULFILLED: {
      return {
        ...state,
        maxLockError: null,
      };
    }
    case SET_MAXES_LOCK_REJECTED: {
      return {
        ...state,
        maxLockError: action.payload,
      };
    }
    case RESET_MAXES_START: {
      return {
        ...state,
        resetMaxesError: null,
      };
    }
    case RESET_MAXES_FULFILLED: {
      return {
        ...state,
        resetMaxesError: null,
      };
    }
    case RESET_MAXES_REJECTED: {
      return {
        ...state,
        resetMaxesError: action.payload,
      };
    }
    case BULK_ARCHIVE_MAXES_START: {
      return {
        ...state,
        bulkArchiveMaxesError: null,
      };
    }
    case BULK_ARCHIVE_MAXES_FULFILLED: {
      return {
        ...state,
        bulkArchiveMaxesError: null,
      };
    }
    case BULK_ARCHIVE_MAXES_REJECTED: {
      return {
        ...state,
        bulkArchiveMaxesError: action.payload,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
